export const mutations = {
  setServiceDetails (state, { key, data }) {
    state.cache = Object.assign({}, state.cache, { [key]: data })
  }
}
